import { format } from 'date-fns';

const DATE_FORMATS = {
    eng: 'MM/dd/yyyy HH:mm',
    rus: 'dd.MM.yyyy HH:mm'
};

export default function formatDate(date, locale) {
    return format(new Date(date), DATE_FORMATS[locale]);
}
